import React, { useEffect, useCallback, useState } from 'react'
import QuizContent from '../shared/QuizContent'
import QuizTitle from '../shared/QuizTitle'
import { getQuizOptionsData, PERSONALITY_TITLES, QUIZ_OPTIONS_DATA } from '../../constants'
import { useQuizSelections } from '../../hooks/useLocalStorage'
import StepSisIcon from '../../assets/stepSisIcon.jsx'
import StepMomIcon from '../../assets/stepMomIcon.jsx'
import GirlfriendIcon from '../../assets/girlfriendIcon.jsx'
import SexFriendIcon from '../../assets/sexFriendIcon.jsx'
import AuthModal from '../shared/AuthModal'
import PlayPauseIcon from '../shared/PlayPauseIcon.jsx'
import LazyImage from '../shared/LazyImage'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSteps } from '../../hooks/useSteps'
import { trackRegistrationModalOpened, trackStep6 } from '../../utils/analytics'

// Функція для генерації випадкових виборів з правильними форматами
const generateRandomSelections = () => {
  const getRandomItem = array => array[Math.floor(Math.random() * array.length)]
  const getRandomAge = () => Math.floor(Math.random() * (55 - 18 + 1)) + 18

  // Спочатку обираємо стиль
  const welcomeOptions = QUIZ_OPTIONS_DATA.welcome
  const randomWelcome = getRandomItem(welcomeOptions)
  const selectedStyle = randomWelcome.value

  // Отримуємо опції для обраного стилю
  const ethnicityOptions = QUIZ_OPTIONS_DATA.ethnicity.filter(opt => !opt.style || opt.style === selectedStyle)
  const bodyTypeOptions = QUIZ_OPTIONS_DATA.bodyType.filter(opt => !opt.style || opt.style === selectedStyle)
  const breastSizeOptions = QUIZ_OPTIONS_DATA.breastSize.filter(opt => !opt.style || opt.style === selectedStyle)
  const buttSizeOptions = QUIZ_OPTIONS_DATA.buttSize.filter(opt => !opt.style || opt.style === selectedStyle)
  const hairColorOptions = QUIZ_OPTIONS_DATA.hairColor.filter(opt => !opt.style || opt.style === selectedStyle)
  const hairStyleOptions = QUIZ_OPTIONS_DATA.hairStyle.filter(opt => !opt.style || opt.style === selectedStyle)
  const eyeColorOptions = QUIZ_OPTIONS_DATA.eyeColor.filter(opt => !opt.style || opt.style === selectedStyle)
  const voiceOptions = QUIZ_OPTIONS_DATA.voice.filter(opt => !opt.style || opt.style === selectedStyle)
  const personalityOptions = QUIZ_OPTIONS_DATA.personality

  const randomVoice = getRandomItem(voiceOptions.length > 0 ? voiceOptions : QUIZ_OPTIONS_DATA.voice)

  const randomSelections = {
    welcome: selectedStyle,
    step1: {
      ethnicity: getRandomItem(ethnicityOptions.length > 0 ? ethnicityOptions : QUIZ_OPTIONS_DATA.ethnicity).value,
      age: getRandomAge(),
    },
    step2: {
      bodyType: getRandomItem(bodyTypeOptions.length > 0 ? bodyTypeOptions : QUIZ_OPTIONS_DATA.bodyType).value,
      breastSize: getRandomItem(breastSizeOptions.length > 0 ? breastSizeOptions : QUIZ_OPTIONS_DATA.breastSize).value,
      buttSize: getRandomItem(buttSizeOptions.length > 0 ? buttSizeOptions : QUIZ_OPTIONS_DATA.buttSize).value,
    },
    step3: {
      hairColor: getRandomItem(hairColorOptions.length > 0 ? hairColorOptions : QUIZ_OPTIONS_DATA.hairColor).value,
      hairStyle: getRandomItem(hairStyleOptions.length > 0 ? hairStyleOptions : QUIZ_OPTIONS_DATA.hairStyle).value,
      eyeColor: getRandomItem(eyeColorOptions.length > 0 ? eyeColorOptions : QUIZ_OPTIONS_DATA.eyeColor).value,
    },
    step4: {
      voice: randomVoice.value,
      voiceAudio: randomVoice.audio,
      personality: getRandomItem(personalityOptions).value,
    },
  }

  return randomSelections
}

const Step5 = ({ onAnswer }) => {
  const { t } = useTranslation()
  const { isShortMode } = useSteps()

  const [selections, setSelections] = useQuizSelections()
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false)
  const [finalSelections, setFinalSelections] = useState(null)
  const location = useLocation()
  const isHalloween = !!location.pathname.includes('/halloween')

  // Final quiz screen reached — fire step_6 once on mount.
  useEffect(() => {
    trackStep6()
  }, [])

  // Проверяем, есть ли все необходимые данные
  const hasAllSelections = useCallback(selectionsData => {
    // Проверка step1
    const hasStep1 =
      selectionsData?.welcome &&
      selectionsData?.step1?.ethnicity &&
      selectionsData?.step1?.age

    // Проверка step2
    const hasStep2 =
      selectionsData?.step2?.bodyType &&
      selectionsData?.step2?.breastSize &&
      selectionsData?.step2?.buttSize

    const commonSelections = hasStep1 && hasStep2

    // ВАЖНО: Определяем режим по ФАКТИЧЕСКИМ данным, а не по текущему GrowthBook значению!
    // Если есть step3 и step4 - значит квиз проходили в BASE режиме (все степы)
    const hasStep3AndStep4 =
      selectionsData?.step3?.hairColor &&
      selectionsData?.step3?.hairStyle &&
      selectionsData?.step3?.eyeColor &&
      selectionsData?.step4?.voice &&
      selectionsData?.step4?.voiceAudio &&
      selectionsData?.step4?.personality

    // Если есть step3 и step4 - это BASE режим
    if (hasStep3AndStep4) {
      return commonSelections && hasStep3AndStep4
    }

    // Если только step1 и step2 - это SHORT режим (без step3/step4)
    // В SHORT режиме после step2 сразу идет step5
    return commonSelections
  }, [])

  useEffect(() => {

    if (location.pathname === '/signup') {
      const randomSelections = generateRandomSelections()
      setFinalSelections(randomSelections)
      setSelections(randomSelections)
    } else {
      if (hasAllSelections(selections)) {
        // Если это SHORT mode (нет step3/step4), добавляем дефолтные значения
        const hasStep3AndStep4 =
          selections?.step3?.hairColor &&
          selections?.step3?.hairStyle &&
          selections?.step3?.eyeColor &&
          selections?.step4?.voice &&
          selections?.step4?.voiceAudio &&
          selections?.step4?.personality

        if (!hasStep3AndStep4 && isShortMode) {
         
          // SHORT mode - добавляем дефолтные значения для step3/step4
          const selectedStyle = selections?.welcome || 'Realistic'
          const hairColorOptions = QUIZ_OPTIONS_DATA.hairColor.filter(opt => !opt.style || opt.style === selectedStyle)
          const hairStyleOptions = QUIZ_OPTIONS_DATA.hairStyle.filter(opt => !opt.style || opt.style === selectedStyle)
          const eyeColorOptions = QUIZ_OPTIONS_DATA.eyeColor.filter(opt => !opt.style || opt.style === selectedStyle)
          const voiceOptions = QUIZ_OPTIONS_DATA.voice.filter(opt => !opt.style || opt.style === selectedStyle)
          const personalityOptions = QUIZ_OPTIONS_DATA.personality

          const defaultVoice = voiceOptions[0] || QUIZ_OPTIONS_DATA.voice[0]

          setFinalSelections({
            ...selections,
            step3: {
              hairColor: hairColorOptions[0]?.value || QUIZ_OPTIONS_DATA.hairColor[0]?.value,
              hairStyle: hairStyleOptions[0]?.value || QUIZ_OPTIONS_DATA.hairStyle[0]?.value,
              eyeColor: eyeColorOptions[0]?.value || QUIZ_OPTIONS_DATA.eyeColor[0]?.value,
            },
            step4: {
              voice: defaultVoice.value,
              voiceAudio: defaultVoice.audio,
              personality: personalityOptions[0]?.value,
            },
          })
        } else {

          setFinalSelections(selections)
        }
      } 
    }
  }, [location.pathname, selections, hasAllSelections, isShortMode])

  const selectedStyle = finalSelections?.welcome || 'Realistic'

  const ethnicities = getQuizOptionsData('ethnicity', selectedStyle)
  const hairColors = getQuizOptionsData('hairColor', selectedStyle)
  const hairStyles = getQuizOptionsData('hairStyle', selectedStyle)
  const bodyTypes = getQuizOptionsData('bodyType', selectedStyle)
  const breastSizes = getQuizOptionsData('breastSize', selectedStyle)
  const bootySizes = getQuizOptionsData('buttSize', selectedStyle)
  const eyeColors = getQuizOptionsData('eyeColor', selectedStyle)

  const handleBringToLife = useCallback(() => {
    trackRegistrationModalOpened()
    setIsAuthModalOpen(true)
  }, [])

  const handleCloseAuthModal = useCallback(() => {
    setIsAuthModalOpen(false)
  }, [])

  const getSelectedVideo = useCallback(() => {
    if (finalSelections?.welcome === 'Realistic') {
      return 'https://cdnsm.swipey.ai/prelander/createsexfriend-grey/Realistic/realistic_createsexfriend_2.mp4'
    } else if (finalSelections?.welcome === 'Anime') {
      return 'https://cdnsm.swipey.ai/prelander/createsexfriend-grey/Anime/anime_createsexfriend.mp4'
    }
    return 'https://cdnsm.swipey.ai/prelander/createsexfriend-grey/Realistic/realistic_createsexfriend_2.mp4'
  }, [finalSelections?.welcome])

  const getSelectedPoster = useCallback(() => {
    if (finalSelections?.welcome === 'Realistic') {
      return 'https://cdnsm.swipey.ai/prelander/createsexfriend-grey/Realistic/step0-image.jpg'
    } else if (finalSelections?.welcome === 'Anime') {
      return 'https://cdnsm.swipey.ai/prelander/createsexfriend-grey/Anime/step0-image.jpg'
    }
    return 'https://cdnsm.swipey.ai/prelander/createsexfriend-grey/Realistic/step0-image.jpg'
  }, [finalSelections?.welcome])

  const getPersonalityIcon = useCallback(() => {
    const personality = finalSelections?.step4?.personality
    switch (personality) {
      case 'stepSis':
        return <StepSisIcon />
      case 'stepMom':
        return <StepMomIcon />
      case 'girlfriend':
        return <GirlfriendIcon />
      case 'sexFriend':
        return <SexFriendIcon />
      default:
        return <GirlfriendIcon />
    }
  }, [finalSelections?.step4?.personality])

  const getPersonalityTitle = useCallback(() => {
    console.log('PERSONALITY_TITLES', PERSONALITY_TITLES)
    const personality = finalSelections?.step4?.personality
    console.log('personality', personality)

    return PERSONALITY_TITLES[personality] || PERSONALITY_TITLES.girlfriend
  }, [finalSelections?.step4?.personality])

  const getEthnicity = useCallback(() => {
    const ethnicity = finalSelections?.step1?.ethnicity
    return (
      ethnicities.find(e => e.value === ethnicity) || {
        image: '/assets/ethnicity-default.png',
        text: 'Unknown',
      }
    )
  }, [finalSelections?.step1?.ethnicity, ethnicities])

  const getVoiceTitle = useCallback(() => {
    const voice = finalSelections?.step4?.voice
    if (voice) {
      const voiceOption = QUIZ_OPTIONS_DATA.voice.find(v => v.value === voice)
      return voiceOption ? t(voiceOption.text) : 'Voice 1'
    }
    return 'Voice 1'
  }, [finalSelections?.step4?.voice])

  const getHairColorImage = useCallback(() => {
    const hairColor = finalSelections?.step3?.hairColor
    const found = hairColors.find(h => h.value === hairColor)
    return found ? found.image : '/assets/step3-hair1.png'
  }, [finalSelections?.step3?.hairColor, hairColors])

  const getHairColorTitle = useCallback(() => {
    const hairColor = finalSelections?.step3?.hairColor
    if (hairColor) {
      const hairColorOption = QUIZ_OPTIONS_DATA.hairColor.find(h => h.value === hairColor)
      return hairColorOption ? t(hairColorOption.text) : t('hairColor.black')
    }
    return 'Black'
  }, [finalSelections?.step3?.hairColor])

  const getHairStyleImage = useCallback(() => {
    const hairStyle = finalSelections?.step3?.hairStyle
    const found = hairStyles.find(h => h.value === hairStyle)
    return found ? found.image : '/assets/step3-hair1.png'
  }, [finalSelections?.step3?.hairStyle, hairStyles])

  const getHairStyleTitle = useCallback(() => {
    const hairStyle = finalSelections?.step3?.hairStyle
    if (hairStyle) {
      const hairStyleOption = QUIZ_OPTIONS_DATA.hairStyle.find(h => h.value === hairStyle)
      return hairStyleOption ? t(hairStyleOption.text) : t('hairStyle.straight')
    }
    return 'Straight'
  }, [finalSelections?.step3?.hairStyle])

  const getBodyTypeImage = useCallback(() => {
    const val = finalSelections?.step2?.bodyType
    const found = bodyTypes.find(b => b.value === val)
    return found ? found.image : '/assets/step2-body1.png'
  }, [finalSelections?.step2?.bodyType, bodyTypes])

  const getBodyTypeTitle = useCallback(() => {
    const bodyType = finalSelections?.step2?.bodyType
    if (bodyType) {
      const bodyTypeOption = QUIZ_OPTIONS_DATA.bodyType.find(b => b.value === bodyType)
      return bodyTypeOption ? t(bodyTypeOption.text) : t('bodyType.slim')
    }
    return 'Slim'
  }, [finalSelections?.step2?.bodyType])

  const getBreastSizeImage = useCallback(() => {
    const val = finalSelections?.step2?.breastSize
    const found = breastSizes.find(b => b.value === val)
    return found ? found.image : '/assets/step2-breast1.png'
  }, [finalSelections?.step2?.breastSize, breastSizes])

  const getBreastSizeTitle = useCallback(() => {
    const breastSize = finalSelections?.step2?.breastSize
    if (breastSize) {
      const breastSizeOption = QUIZ_OPTIONS_DATA.breastSize.find(b => b.value === breastSize)
      return breastSizeOption ? t(breastSizeOption.text) : t('breastSize.small')
    }
    return 'Small'
  }, [finalSelections?.step2?.breastSize])

  const getBootySizeImage = useCallback(() => {
    const val = finalSelections?.step2?.buttSize
    const found = bootySizes.find(b => b.value === val)
    return found ? found.image : '/assets/step2-booty1.png'
  }, [finalSelections?.step2?.buttSize, bootySizes])

  const getBootySizeTitle = useCallback(() => {
    const bootySize = finalSelections?.step2?.buttSize
    if (bootySize) {
      const bootySizeOption = QUIZ_OPTIONS_DATA.buttSize.find(b => b.value === bootySize)
      return bootySizeOption ? t(bootySizeOption.text) : t('buttSize.small')
    }
    return 'Small'
  }, [finalSelections?.step2?.buttSize])

  const getEyeColorTitle = useCallback(() => {
    const eyeColor = finalSelections?.step3?.eyeColor
    if (eyeColor) {
      const eyeColorOption = QUIZ_OPTIONS_DATA.eyeColor.find(e => e.value === eyeColor)
      return eyeColorOption ? t(eyeColorOption.text) : t('eyeColor.brown')
    }
    return 'Brown'
  }, [finalSelections?.step3?.eyeColor])

  const getEyeColorImage = useCallback(() => {
    const val = finalSelections?.step3?.eyeColor
    const found = eyeColors.find(e => e.value === val)
    return found ? found.image : '/assets/step3-eye1.png'
  }, [finalSelections?.step3?.eyeColor, eyeColors])

  const getVoiceAudio = useCallback(() => {
    return finalSelections?.step4?.voiceAudio || null
  }, [finalSelections?.step4?.voiceAudio])

  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = React.useRef(null)

  const togglePlay = useCallback(() => {
    if (!audioRef.current) return
    if (isPlaying) {
      audioRef.current.pause()
      setIsPlaying(false)
    } else {
      audioRef.current.play()
      setIsPlaying(true)
      audioRef.current.onended = () => setIsPlaying(false)
    }
  }, [isPlaying])

  if (!finalSelections?.welcome) {
    return (
      <div className='quizContentWrapper lastStep'>
        <QuizContent>
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <p>{t('loading')}</p>
          </div>
        </QuizContent>
      </div>
    )
  }
  console.log('finalSelections', finalSelections)
  return (
    <div className='quizContentWrapper lastStep'>
      <QuizContent className='step5-design'>
        <QuizTitle>
          {isHalloween ? (
            <>
              {t('your')}
              <span className='specialText'> {t('fantasy_babe_text')} </span>
              {t('is_ready')}
            </>
          ) : (
            t('fantasy_babe')
          )}
        </QuizTitle>
        <div className='result-grid'>
          {isShortMode ? (
            <>
              {/* SHORT mode: Same structure as BASE, just fewer cards */}
              {/* Left - Main Video */}
              <div className='result-main '>
                <video
                  src={getSelectedVideo()}
                  poster={getSelectedPoster()}
                  autoPlay
                  loop
                  muted
                  preload='metadata'
                  playsInline
                  controls={false}
                  className='step0Video'
                />
                <div className='result-main-label'>{t(finalSelections.welcome)}</div>
              </div>

              {/* Right - Cards Grid (5 cards total) */}
              <div className='result-cards short-result-cards'>
                {/* Row 1 */}
                <div className='result-card result-card-ethnicity'>
                  <LazyImage src={getEthnicity().image} alt={getEthnicity().text} />
                  <span>{t(getEthnicity().text)}</span>
                </div>
                <div className='result-card'>
                  <LazyImage src={getBodyTypeImage()} alt={getBodyTypeTitle()} />
                  <span>{getBodyTypeTitle()}</span>
                </div>

                {/* Row 2 */}
                <div className='result-card'>
                  <LazyImage src={getBreastSizeImage()} alt={getBreastSizeTitle()} />
                  <span>{getBreastSizeTitle()}</span>
                </div>
                <div className='result-card'>
                  <LazyImage src={getBootySizeImage()} alt={getBootySizeTitle()} />
                  <span>{getBootySizeTitle()}</span>
                </div>

                {/* Row 3 - Age card spans 2 columns */}
                <div className='result-card result-card-age  result-card-wide'>
                  <div className='age-number specialText'>{finalSelections.step1?.age || 22}</div>
                  <span>{t('years')}</span>
                </div>
              </div>
            </>
          ) : (
            <>
              {/* BASE mode: Original layout */}
              {/* Left - Main Video */}
              <div className='result-main'>
                <video
                  src={getSelectedVideo()}
                  poster={getSelectedPoster()}
                  autoPlay
                  loop
                  muted
                  preload='metadata'
                  playsInline
                  controls={false}
                  className='step0Video'
                />
                <div className='result-main-label'>{t(finalSelections.welcome)}</div>
              </div>

              {/* Right - Cards Grid */}
              <div className='result-cards'>
                {/* Row 1 */}
                <div className='result-card result-card-ethnicity'>
                  <LazyImage src={getEthnicity().image} alt={getEthnicity().text} />
                  <span>{t(getEthnicity().text)}</span>
                </div>
                <div className='result-card result-card-age'>
                  <div className='age-number specialText'>{finalSelections.step1?.age || 22}</div>
                  <span>{t('years')}</span>
                </div>

                {/* Row 2 */}
                <div className='result-card'>
                  <LazyImage src={getBodyTypeImage()} alt={getBodyTypeTitle()} />
                  <span>{getBodyTypeTitle()}</span>
                </div>
                <div className='result-card'>
                  <LazyImage src={getBreastSizeImage()} alt={getBreastSizeTitle()} />
                  <span>{getBreastSizeTitle()}</span>
                </div>

                {/* Row 3 */}
                <div className='result-card'>
                  <LazyImage src={getBootySizeImage()} alt={getBootySizeTitle()} />
                  <span>{getBootySizeTitle()}</span>
                </div>
                <div className='result-card'>
                  <LazyImage src={getHairStyleImage()} alt={getHairStyleTitle()} />
                  <span>{getHairStyleTitle()}</span>
                </div>

                {/* Row 4 */}
                <div className='result-card'>
                  <LazyImage src={getHairColorImage()} alt={getHairColorTitle()} />
                  <span>{getHairColorTitle()}</span>
                </div>
                <div className='result-card'>
                  <LazyImage src={getEyeColorImage()} alt={getEyeColorTitle()} />
                  <span>{getEyeColorTitle()}</span>
                </div>

                {/* Row 5 */}
                <div className='result-card result-card-voice' onClick={togglePlay}>
                  <PlayPauseIcon isPlaying={isPlaying} />
                  <span>{getVoiceTitle()}</span>
                  {getVoiceAudio() && <audio ref={audioRef} src={getVoiceAudio()} preload='metadata' />}
                </div>
                <div className='result-card result-card-personality'>
                  <div className='personality-icon-wrapper'>{getPersonalityIcon()}</div>
                  <span>{t(getPersonalityTitle())}</span>
                </div>
              </div>
            </>
          )}
        </div>

        {/* CTA Button */}
        <div className='cta-container'>
          <button className='bring-to-life-button' onClick={handleBringToLife}>
            <span className='sparkle-icon'>✨</span>
            <span style={{ textTransform: 'uppercase' }}>{t('bring_ai')}</span>
          </button>
        </div>
      </QuizContent>
      <AuthModal isOpen={isAuthModalOpen} onClose={handleCloseAuthModal} selectedStyle={finalSelections?.welcome} />
    </div>
  )
}

export default Step5
